<template>
  <h1 class="pageHeader" :v-html="text" v-bind:style="{color: color === 'black' ? '#2E2F34' : '#fff' }">
    <slot></slot>
  </h1>
</template>

<script>

  export default {
    name: 'PageHeader',
    props: ['color', 'text'],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
    }
  }
</script>

<style lang="scss">
  @import "src/assets/scss/variables";

  .pageHeader {
    font-family: -apple-system, system-ui, BlinkMacSystemFont;
    font-style: normal;
    font-weight: normal;;
    font-size: $headerFontSize;
    margin-left: $primaryMargin;
    margin-right: $primaryMargin;

    text-align: center;
  }

</style>
